<template>
    <div class="coverdetailsbloc">
        <span class="info-title">{{$t('Cover.ShowCover.INVOICE_DETAILS_SUB_TITLE')}}</span>
        <div class="divider">
            <v-divider></v-divider>
        </div>
        <div class="coverdetailsbloccontent">
            <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.ISSUE_DATE_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                  {{cover.invoice.issuedAt}}
               </v-flex>
            </v-layout>
            <v-layout row  class="detailfieldinfo">
               <v-flex xs6>
                 <v-label>{{$t('Cover.ShowCover.DUE_DATE_FIELD_NAME')}} : </v-label>
               </v-flex>
                <v-flex v-if="cover.invoice.isDueDatePassed" xs6 class="latedetails">
                    {{cover.invoice.dueAt}}
                    <p class="lateinfo">
                        {{$t('Cover.ShowCover.DAYS_LATE_DESC', { daysLateNumber: cover.invoice.daysLate })}}
                    </p>
                </v-flex>
                <v-flex v-else xs6>
                    {{cover.invoice.dueAt}}
                </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.INVOICE_VALUE_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.amount}}
                </v-flex>
            </v-layout>
            <div class="detailsinfo">
                <span class="sub-title-header">{{$t('Cover.ShowCover.SELLER_SUB_TITLE')}}</span>
            </div>
            <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.COMPANY_NAME_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.seller.name}}
                </v-flex>
            </v-layout>
             <v-layout v-if="cover.invoice.seller.identifierType" row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{cover.invoice.seller.identifierType}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.seller.identifierValue}}
                </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.ADDRESS_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    <p class="address">{{cover.invoice.seller.streetNumber}} {{cover.invoice.seller.address.streetName}}</p>
                    <p class="address">{{cover.invoice.seller.address.postCode}} {{cover.invoice.seller.address.city}}</p>
                    <p class="address">{{cover.invoice.seller.address.country}}</p>
                </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.SIC_ID_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{displayedSellerId}}
                </v-flex>
            </v-layout>
            <div class="detailsinfo">
                <span class="sub-title-header">{{$t('Cover.ShowCover.BUYER_SUB_TITLE')}}</span>
            </div>
            <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.COMPANY_NAME_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.buyer.name}}
                </v-flex>
            </v-layout>
             <v-layout  v-if="cover.invoice.buyer.identifierType"  row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{cover.invoice.buyer.identifierType}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{cover.invoice.buyer.identifierValue}}
                </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.ADDRESS_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    <p class="address">{{cover.invoice.buyer.streetNumber}} {{cover.invoice.buyer.address.streetName}}</p>
                    <p class="address">{{cover.invoice.buyer.address.postCode}} {{cover.invoice.buyer.address.city}}</p>
                    <p class="address">{{cover.invoice.buyer.address.country}}</p>
                </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
                <v-flex xs6>
                    <v-label>{{$t('Cover.ShowCover.SIC_ID_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{displayedBuyerId}}
                </v-flex>
            </v-layout>
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('cover', ['cover']),
    ...mapState('userdetails', ['userInfos']),
    displayedSellerId: function () {
      return this.cover.invoice.seller.id
    },
    displayedBuyerId: function () {
      return this.cover.invoice.buyer.id
    }
  }
}
</script>
<style>

.lateinfo {
    font-size: 11.0px;
    color: rgba(238, 0, 0, 1.0);
}
.latedetails {
     color: rgba(238, 0, 0, 1.0);
}
.detailfieldinfo {
    padding-top: 5px
}

.companydetailscontent {
    padding-top: 15px
}

.address {
    margin-bottom: 0px
}
</style>
